import { render, staticRenderFns } from "./DrawScreen.vue?vue&type=template&id=69013200&scoped=true&"
import script from "./DrawScreen.vue?vue&type=script&lang=js&"
export * from "./DrawScreen.vue?vue&type=script&lang=js&"
import style0 from "./DrawScreen.vue?vue&type=style&index=0&id=69013200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../mobile.zyp.one/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69013200",
  null
  
)

export default component.exports